import {
  addCurrentAuthHeader,
  type SessionService,
} from '@efdigital/ll-addon-auth';

import { parseAdminSessionsErrorResponse } from './admin-sessions.ts';

const AI_MATCHING_API_PREFIX = '/ll-coaching-ai-matching/admin';

/**
 * `@efdigital/ll-cdk-coaching-ai-matching-api-types` doesn't publish the admin
 * path yet. The response is the same `CoachMatch[]` the coachee route returns —
 * typed locally to match that contract until a release picks the admin types up.
 */
export type CoachAvailabilityTier = 'poor' | 'some' | 'good' | 'unknown';

export type CoachMatchContribution = {
  baseValue: number;
  languageMatch: number;
  industryMatch: number;
  seniorityMatch: number;
  embeddingSimilarity: number;
};

export type CoachMatch = {
  coachId: string;
  relevance: number;
  contribution: CoachMatchContribution;
  availabilityTier: CoachAvailabilityTier;
};

export type CohortCoachMatchesResponseBody = CoachMatch[];

export async function buildAdminCoachMatchesRequest(
  session: SessionService,
  cohortId: string,
  coacheeId: string
): Promise<Request> {
  const init = await addCurrentAuthHeader(
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    { session }
  );

  return new Request(
    `${session.apis.systemsApi.host}${AI_MATCHING_API_PREFIX}/cohorts/${encodeURIComponent(cohortId)}/coachees/${encodeURIComponent(coacheeId)}/coach-matches`,
    init
  );
}

export async function parseAdminCoachMatchesResponse(
  response: Response
): Promise<CoachMatch[]> {
  if (!response.ok) {
    return parseAdminSessionsErrorResponse(response);
  }

  return (await response.json()) as CohortCoachMatchesResponseBody;
}
